module.exports = __webpack_public_path__ + "static/mediex-ci-color-7c79602c161ac96628b8ff71001a0209.png";